import {Button, Checkbox, Grid, IconButton, TextField} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {PayloadUpdate, Webhook, WebhookType} from './interfaces';
import {createStructuredSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {makeSelectError, makeSelectLoading} from './selectors';
import {deleteWebhooksActions, updateWebhooksActions} from './actions';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {translate} from '../../utils/helpers';
import RonadIcons from '../../components/iconComponent';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '8px',
    },
  })
);

export type Props = {
  webhook: Webhook;
  updateWebhooksDispatch?: (payload: PayloadUpdate) => void;
  deleteWebhookDispatch?: (payload: {id: number}) => void;
  loading?: boolean;
};

export type SelectorProps = {
  loading: boolean;
  error: '';
};

function WebhookComponent(props: Props) {
  const classes = useStyles();
  const [id, setId] = useState<number>(-1);
  const [status, setStatus] = useState('');
  const [serviceUrl, setServiceUrl] = useState('');
  const [webhookType, setWebhookType] = useState<any>('' as WebhookType);

  useEffect(() => {
    setId(props.webhook.id);
    setStatus(props.webhook.status);
    setServiceUrl(props.webhook.serviceUrl);
    setWebhookType(props.webhook.webhookType);
  }, []);

  const updateWebhook = () => {
    props?.updateWebhooksDispatch({
      body: {
        id,
        status,
        serviceUrl,
        webhookType,
      },
      pagination: {
        page: 0,
        size: 10,
      },
    });
  };

  const handleCheck = (event: any) => {
    const currentStatus = event.target.checked ? 'ACTIVE' : 'SUSPENDED';
    setStatus(currentStatus);
  };

  const deleteWebhook = () => {
    props?.deleteWebhookDispatch({id});
  };

  return (
    <>
      <Grid container item xs={12} alignItems="center">
        <div className={classes.item}>
          <span className={classes.label}>
            <Checkbox
              checked={status === 'ACTIVE'}
              onChange={handleCheck}
              name={webhookType}
            />
          </span>

          <span style={{width: '100%'}}>
            <TextField
              type="text"
              fullWidth
              id="webHookUrl"
              label={translate(webhookType)}
              name="webHookUrl"
              value={serviceUrl}
              onChange={e => setServiceUrl(e.target.value)}
            />
          </span>
        </div>
      </Grid>
      <Grid item container xs={12} justify="flex-end" spacing={2}>
        <Grid item>
          <Button
            type="button"
            fullWidth
            size="medium"
            variant="contained"
            color="secondary"
            disabled={props.loading}
            onClick={updateWebhook}
            startIcon={<RonadIcons name='pencil'/>}
          >
            {'ویرایش'}
          </Button>
        </Grid>
        <Grid item>
          <Button
            type="button"
            fullWidth
            size="medium"
            variant="contained"
            color="primary"
            disabled={props.loading}
            onClick={deleteWebhook}
            startIcon={<RonadIcons name='trash' size={0.8} />}
          >
            {'حذف'}
          </Button>
        </Grid>
      </Grid>
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    updateWebhooksDispatch: (payload: PayloadUpdate) =>
      dispatch(updateWebhooksActions(payload)),
    deleteWebhookDispatch: (payload: {id: number}) =>
      dispatch(deleteWebhooksActions(payload)),
  };
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(WebhookComponent);
